import Swal from 'sweetalert2/dist/sweetalert2.min.js';
import { translate } from '@/core/helpers/language';
import { i18n } from '@/localization/index';
const { t, te } = i18n.global;
const swalFire = (alertObj) => {
    return Swal.fire(alertObj);
};
export const swalAlertSuccess = (text, confirmButtonText, showCancelButton = false) => {
    return swalFire({
        text: text,
        title: '<h6 style="font-size:35px;font-weight:600;margin-bottom: -16px;">Success!</h6>',
        imageUrl: 'media/icons/custom/popup-success-icon.svg',
        showCancelButton: showCancelButton,
        buttonsStyling: false,
        confirmButtonText: confirmButtonText,
        customClass: {
            confirmButton: 'btn fw-bold btn-light-success'
        }
    });
};
export const swalAlertError = (text, confirmButtonText, showCancelButton = false) => {
    return swalFire({
        text: text,
        icon: 'error',
        showCancelButton: showCancelButton,
        buttonsStyling: false,
        confirmButtonText: confirmButtonText,
        customClass: {
            confirmButton: 'btn fw-bold btn-light-danger'
        }
    });
};
export const swalAlertWarning = (text, confirmButtonText, showCancelButton = false) => {
    return swalFire({
        text: text,
        icon: 'warning',
        showCancelButton: showCancelButton,
        buttonsStyling: false,
        confirmButtonText: confirmButtonText,
        customClass: {
            confirmButton: 'btn btn-primary'
        }
    });
};
export const swalAlertInfo = (text, confirmButtonText, showCancelButton = false) => {
    return swalFire({
        text: text,
        icon: 'info',
        showCancelButton: showCancelButton,
        buttonsStyling: false,
        confirmButtonText: confirmButtonText,
        customClass: {
            confirmButton: 'btn btn-primary'
        }
    });
};
export const swalAlertQuestion = (text, confirmButtonText, showCancelButton = false) => {
    return swalFire({
        text: text,
        icon: 'question',
        showCancelButton: showCancelButton,
        buttonsStyling: false,
        confirmButtonText: confirmButtonText,
        customClass: {
            confirmButton: 'btn btn-primary'
        }
    });
};
export const swalAlertConfirmation = (text, confirmLabel = '', imageUrl = '') => {
    if (!confirmLabel) {
        confirmLabel = translate('SUBMIT', t, te);
    }
    return swalFire({
        title: translate('CONFIRMATION', t, te),
        text: text ? text : translate('AREYOUSURE', t, te),
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: confirmLabel,
        cancelButtonText: translate('CANCEL', t, te),
        imageUrl: imageUrl,
        customClass: {
            confirmButton: 'btn btn-primary btn-block w-100',
            cancelButton: 'btn btn-secondary btn-block w-100',
            content: 'custom-swal-content',
            header: 'custom-swal-header',
            title: 'custom-swal-title',
            container: 'custom-swal-confirmation',
            actions: 'custom-swal-actions',
            closeButton: 'custom-swal-close-button'
        },
        showCloseButton: true,
        reverseButtons: true
    });
};
export const swalAlertErrorBulk = (text) => {
    return swalFire({
        title: "<div style='display: flex;align-items: center;justify-content: center;'><img src='media/svg/misc/error-icon.svg'/><span style='margin-left:6px;'>Something went wrong</span></div>",
        text: text,
        buttonsStyling: false,
        confirmButtonText: translate('OKGOTIT', t, te),
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-secondary',
            content: 'custom-swal-content',
            header: 'custom-swal-header',
            title: 'custom-swal-title',
            container: 'custom-swal-confirmation',
            actions: 'custom-swal-actions',
            closeButton: 'custom-swal-close-button'
        }
    });
};
export const hrgsSwalAlert = (config) => {
    let title = '';
    switch (config.icon) {
        case 'error':
            title = 'Error!';
            break;
        case 'info':
            title = 'Information';
            break;
        case 'success':
            title = 'Success!';
            break;
        case 'warning':
            title = 'Confirmation';
            break;
    }
    return Swal.fire(Object.assign(Object.assign(Object.assign(Object.assign({ confirmButtonText: 'Close', imageUrl: `media/svg/misc/document-${config.icon}.svg` }, (config.icon === 'warning' && { showCancelButton: true })), { title, customClass: {
            content: 'custom-swal-content',
            header: 'custom-swal-header',
            title: 'custom-swal-title',
            container: 'custom-swal-confirmation'
        } }), config), { icon: null }));
};
export const swalAlertYesNo = (text, confirmButtonText, denyButtonText, showCancelButton = true
// showDenyButton = true,
) => {
    return swalFire({
        text: text,
        confirmButtonText: confirmButtonText,
        denyButtonText: denyButtonText,
        showCancelButton: showCancelButton,
        // showDenyButton: showDenyButton,
        buttonsStyling: false,
        customClass: {
            // confirmButton: "btn fw-bold btn-light-danger",
            confirmButton: 'btn btn-success fw-bold',
            cancelButton: 'btn btn-danger fw-bold'
        }
    });
};
